import { useState } from "react";
import firebaseService from "../../../firebase_service/firebaseService";
import useClearGiftMutation from "./useClearGiftMutation";
import useDeviceGiftQuery from "./useDeviceGiftQuery";
import { Klydo } from "../../../Types";
import useDeviceQuery from "./useDeviceQuery";
import giftCategoriesClient from "../../../api/giftCategories";

const useDeviceModal = (id: string) => {
  const { data: machineData, isLoading, refetch } = useDeviceQuery(id);
  const [showKlydoViewingModal, setShowKlydoViewingModal] = useState(false);
  const { data: gift, refetch: refetchGift } = useDeviceGiftQuery(id);
  const { mutateAsync: clearGift } = useClearGiftMutation(id);
  const [updateDevApp, setUpdateDevApp] = useState(false);
  const [updateVersion, setUpdateVersion] = useState(
    firebaseService.general?.last,
  );
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateAppLoader, setUpdateAppLoader] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [warning, setWarning] = useState("");
  const [klydoAnalyticData, setKlydoAnalyticData] = useState<
    Array<{
      clockTime: Date;
      displayTime: number;
      klydo?: Klydo;
      autoSwitch: boolean;
      favorite: boolean;
      collectionType: string;
    }>
  >();
  const [tableId] = useState("klydo-history");
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);

  function handleRef() {
    const ref = "https://klydo-editor.web.app/klydo/" + machineData?.klydo?.id;
    return ref as string;
  }

  return {
    data: machineData,
    refetch,
    isLoading,
    showKlydoViewingModal,
    setShowKlydoViewingModal,
    gift,
    refetchGift,
    deleteGift: async () => {
      if (!gift?.orderName) return;
      await giftCategoriesClient.deleteOrderGift(gift.orderName);
      await refetchGift();
    },
    detachClock: async () => {
      await clearGift();
    },
    hideDev: machineData?.hideDev?.value === false ? false : true,
    currentKlydo:
      machineData?.klydo?.id || "f90e5246-a4b2-4bf5-81ee-5f8d22241074",
    timeOffset: machineData?.timeOffset ? machineData.timeOffset.value : 0,
    updateDevApp,
    setUpdateDevApp,
    updateVersion,
    setUpdateVersion,
    showUpdateModal,
    setShowUpdateModal,
    updateAppLoader,
    setUpdateAppLoader,
    schedualOn: machineData?.nightMode
      ? machineData.nightMode.value === "SCHEDULE"
      : false,
    showRemoveModal,
    setShowRemoveModal,
    warning,
    setWarning,
    klydoAnalyticData,
    setKlydoAnalyticData,
    tableId,
    showRegisterDialog,
    setShowRegisterDialog,
    handleRef,
  };
};

export default useDeviceModal;
